import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { HubProfileStorageService } from "@/infrastructure/storage/HubProfileStorageService";
import { LocalStorageService } from "@/infrastructure/storage/LocalStorageService";

// Module-scoped storage service. The store boot-straps at first import, before
// the React tree exists, so we can't depend on the DI graph here.
const hubProfileStorage = new HubProfileStorageService(new LocalStorageService());

interface HubProfileUIState {
  selectedProfileUuid: string | null;
  isSwitchingProfile: boolean;
  setSelectedProfile: (uuid: string | null) => void;
  setIsSwitchingProfile: (switching: boolean) => void;
  clearSwitchingState: () => void;
  reset: () => void;
}

export const useHubProfileStore = create<HubProfileUIState>()(
  devtools(
    (set) => ({
      selectedProfileUuid: hubProfileStorage.getSelectedProfileUuid(),
      isSwitchingProfile: false,
      setSelectedProfile: (uuid) => set({ selectedProfileUuid: uuid }),
      setIsSwitchingProfile: (switching) => set({ isSwitchingProfile: switching }),
      clearSwitchingState: () => set({ isSwitchingProfile: false }),
      reset: () => set({ selectedProfileUuid: null, isSwitchingProfile: false }),
    }),
    { name: "HubProfileStore" },
  ),
);
